import { getAppData } from '../../lib/api/common';
import {
	getCompanies,
	getCompanySiteData,
	getCompanySubPages,
	getCompanySubPageByUri
} from '../../lib/api/company';

import { getLatestNewsBlockItems } from '../../lib/api/news'
import { getFeaturedDealsBlockItems } from '../../lib/api/deals'

import Layout from '../../components/layout/Layout';
import SeoMaticHead from '../../components/common/SeoMaticHead'
import CompanyPage from '../../components/content/page/CompanyPage'
import { revalidateSeconds } from "../../lib/helpers/revalidateSeconds";

export type CompanySubPageProps = {
	page: any
	companySiteData: any
	app: any
	dynamicData: any
}


export async function getStaticPaths() {

	// Get all companies and use as base segment
	const companies: any = await getCompanies();


	const paths = []
	for ( let company of companies.entries ) {

		const pages: any = await getCompanySubPages( company.uri )
		if ( pages?.entries ) {

			for ( let page of pages.entries ) {

				const uri = page.uri.split('/')
				const splitUri = uri.shift() // Removing first item ( siteHandle ) from array

				paths.push({
					params: {
						siteHandle: company.slug,
						uri: uri
					}
				})
			}
		}
	}


	return {
		paths,
		fallback: 'blocking',
	}
}


export async function getStaticProps(context: any) {

	const siteHandle: string = context?.params?.siteHandle
	const uri: Array<string> = context?.params?.uri


	// Add sitehandle to the front of uri array
	uri.unshift(siteHandle)


	// Fetch page data
	const data: any = await getCompanySubPageByUri(
		uri.join('/'),
		context.preview ? context.previewData?.token : undefined
	);


	// Return 404 if no page is found
	if (!data.page) {
		return {
			notFound: true,
			revalidate: revalidateSeconds()
		}
	}


	// Fetches global navigation and footer data
	const app: any = await getAppData();

	// Fetches company specific navigation
	const companySiteData: any = await getCompanySiteData(siteHandle);

	// Check for dynamic content blocks
	const latestNewsBlocks = data.page.pageBuilder?.filter((block: any) => block.typeHandle === 'latestNews')
	const featuredDealsBlocks = data.page.pageBuilder?.filter((block: any) => block.typeHandle === 'featuredDeals')

	// Get latest news if block is present
	const latestNews = latestNewsBlocks && latestNewsBlocks.length > 0 ? await getLatestNewsBlockItems( siteHandle ) : null

	// Get latest featured deals if block is present and no deals are selected
	const getLatestDeals = featuredDealsBlocks?.length > 0
	const featuredDeals = getLatestDeals ? await getFeaturedDealsBlockItems() : null

	// Add solutions for events, offerings and other dynamic types


	return {
		props: {
			app: app,
			page: data.page,
			companySiteData: companySiteData,
			dynamicData: {
				news: latestNews?.news ? latestNews.news : null,
				featuredDeals: featuredDeals?.deals ? featuredDeals.deals : null
			}
		},
		revalidate: revalidateSeconds()
	}
}


export default function CompanySubPage(props: CompanySubPageProps) {

	const { page, companySiteData, app, dynamicData } = props

	// console.log('CompanySubPage page: ', page)

	return (
		<>
			<SeoMaticHead seo={page.seo} />
			<Layout
				key={page.id}
				appData={app}
				companySiteData={companySiteData}
			>
				<CompanyPage
					page={page}
					companySiteData={companySiteData}
					dynamicData={dynamicData}
				/>
			</Layout>
		</>
	)

}
